var module = angular.module('main.resellerorder');

module.component('createResellerorderFulfillmentVariants', {
    templateUrl: 'main/resellerorder/resellerorderfulfillment/createfulfillment/components/createfulfillmentvariants.cmp.tpl.html',
    bindings: {
        selectedProduct: '<',
        selectedWarehouse: '<',
        minimumAvailableStock: '<',
        onAppliedFulfillment: '&'
    },
    controllerAs: 'vm',
    controller: componentController
});

// @ngInject
function componentController($scope, $state, $window, $translate, ResellerOrdersApiService, loadSpinnerService, confirmationDialogService) {
    var vm = this;

    //Properties
    vm.allKeepRemainder = true;
    var canNotConfirmFulfillmentBecauseOfTooLowStockQuantities = '';
    var canNotConfirmFulfillmentBecauseOfZeroQuantities = '';

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.getFulfillableQuantitySum = getFulfillableQuantitySum;
    vm.getQuantitySum = getQuantitySum;
    vm.getDifference = getDifference;
    vm.getStockQuantity = getStockQuantity;
    vm.clearRowQuantities = clearRowQuantities;
    vm.resetRowQuantities = resetRowQuantities;
    vm.canResetRowQuantities = canResetRowQuantities;
    vm.clearAllRowQuantities = clearAllRowQuantities;
    vm.resetAllRowQuantities = resetAllRowQuantities;
    vm.canResetAllRowQuantities = canResetAllRowQuantities;
    vm.formatDifference = formatDifference;
    vm.canApplyFulfillment = canApplyFulfillment;
    vm.applyFulfillment = applyFulfillment;
    vm.getApplyFulfillmentTooltipText = getApplyFulfillmentTooltipText;
    vm.preventInputLessThanZero = preventInputLessThanZero;
    vm.goToOrder = goToOrder;

    activate();

    function onInit() {
        
    }
    function onChanges() {
       
    }

    function goToOrder(orderId) {
        var url = $state.href('resellerorder.resellerorderview', {orderId: orderId});
        $window.open(url,'_blank');
    }

    function activate() {
        loadFulfillableOrders();
        var result = _.sortBy(vm.selectedProduct.variantList, function(variant) { return variant.variant2SortOrder; });
        console.log(result);
        $scope.$watch(function () { return vm.allKeepRemainder; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                _.forEach(vm.selectedProduct.variants, function (ordVar) {
                    ordVar.keepRemainder = vm.allKeepRemainder;
                });
            }
        });
        canNotConfirmFulfillmentBecauseOfTooLowStockQuantities = $translate.instant('resellerorder.canNotConfirmFulfillmentBecauseOfTooLowStockQuantities');
        canNotConfirmFulfillmentBecauseOfZeroQuantities = $translate.instant('resellerorder.canNotConfirmFulfillmentBecauseOfZeroQuantities');
    }

    function getApplyFulfillmentTooltipText() {
        if (!vm.selectedProduct || !vm.selectedProduct.variants || vm.selectedProduct.variants.length === 0) { return false; }

        if (hasPositiveDiff() === false) {
            return canNotConfirmFulfillmentBecauseOfTooLowStockQuantities;
        }
        if (hasPositiveTotal() === false) {
            return canNotConfirmFulfillmentBecauseOfZeroQuantities;
        }
        return '';
    }
    function canApplyFulfillment() {
        if (!vm.selectedProduct || !vm.selectedProduct.variants || vm.selectedProduct.variants.length === 0) { return false; }

        var fulfillHasPositiveDiff = true;
        var nonFakeArtVarId = [];


        // Finds all variantId's in all lineitems that aren't fake. And adds the correct {VariandId, Quantity} to nonFakeArtVarId array.
        _.forEach(vm.selectedProduct.variants, function(variant){  
            _.forEach(variant.lineItems, function(lineItem){
                if(!lineItem.isFake){
                    var canBeAddedToArray = !_.find(nonFakeArtVarId, function(artVarId) { return artVarId.variantId === lineItem.articleVariantId})
                    if(canBeAddedToArray)
                        nonFakeArtVarId.push({variantId : lineItem.articleVariantId , quantity : lineItem.quantity});
                    else{ // Increase the quantity
                        _.find(nonFakeArtVarId, function(artVarId) { 
                            if(artVarId.variantId === lineItem.articleVariantId) {
                                artVarId.quantity += lineItem.quantity;
                            }
                        });
                    }
                }
            });
        });

        // Checks if there are any negative diffs after fulfillment
        _.forEach(vm.selectedProduct.variantList, function(varL){
            if(fulfillHasPositiveDiff){
                _.find(nonFakeArtVarId, function(artVarId) 
                { 
                    if(artVarId.variantId === varL.id){
                        if(varL.stockQuantity - artVarId.quantity < 0)
                            fulfillHasPositiveDiff = false;
                        if(artVarId.quantity === 0)
                            fulfillHasPositiveDiff = true;

                    } 
                });
            }
        });

        return fulfillHasPositiveDiff;
    }
    function hasPositiveDiff() {
        var canApplyFulfillment = true;

        _.forEach(vm.selectedProduct.variantNames, function (variantName) {
            var diff = getDifference(variantName);
            if (diff < 0) {
                canApplyFulfillment = false;
            }
        });

        return canApplyFulfillment;
    }
    function hasPositiveTotal() {
        var totalDiff = 0;
        _.forEach(vm.selectedProduct.variantNames, function (variantName) {
            totalDiff += getQuantitySum(variantName);
        });

        return totalDiff > 0;
    }
    function applyFulfillment() {
        confirmationDialogService.showDialog($translate.instant('resellerorder.confirmApplyFulfillment'), $translate.instant('common.warning')).then(function (result) {
            if (result === true) {
                var itemsToFulfill = [];

                _.forEach(vm.selectedProduct.variants, function (ordVar) {
                    _.forEach(ordVar.lineItems, function (li) {
                        if (!li.isFake) {
                            var newItem = {
                                orderId: li.orderId,
                                lineItemId: li.lineItemId,
                                articleVariantId: li.articleVariantId,
                                quantity: li.quantity,
                                closeOrderLine: !ordVar.keepRemainder
                            };
                            itemsToFulfill.push(newItem);
                        }
                    });
                });

                vm.onAppliedFulfillment({ itemsToFulfill: itemsToFulfill });
            }
        });
    }

    function getStockQuantity(variantName) {
        if (!variantName || variantName === '') { return 0; }

        var stockQuantity = 0;
        try {
            _.forEach(vm.selectedProduct.variantList, function (variant) {
                if(variantName === variant.variant2DetailName){
                    stockQuantity = variant.stockQuantity;
                }
            });
        } catch (error) {
            console.log(error);
        }

        return stockQuantity;
    }

    function clearRowQuantities(variant) {
        _.forEach(variant.lineItems, function (li) {
            li.quantity = 0;
        });
    }

    function resetRowQuantities(variant) {
        _.forEach(variant.lineItems, function (li) {
            li.quantity = li.fulfillableQuantity;
        });
    }

    function canResetRowQuantities(variant) {
        var canResetRowQuantities = false;
        _.forEach(variant.lineItems, function (li) {
            if (li.quantity !== li.fulfillableQuantity) {
                canResetRowQuantities = true;
            }
        });

        return canResetRowQuantities;
    }

    function clearAllRowQuantities() {
        _.forEach(vm.selectedProduct.variants, function (ordVar) {
            _.forEach(ordVar.lineItems, function (li) {
                li.quantity = 0;
            });
        });
    }

    function resetAllRowQuantities() {
        _.forEach(vm.selectedProduct.variants, function (ordVar) {
            _.forEach(ordVar.lineItems, function (li) {
                li.quantity = li.fulfillableQuantity;
            });
        });
    }

    function canResetAllRowQuantities() {
        var canResetAllRowQuantities = false;
        _.forEach(vm.selectedProduct.variants, function (ordVar) {
            _.forEach(ordVar.lineItems, function (li) {
                if (li.quantity !== li.fulfillableQuantity) {
                    canResetAllRowQuantities = true;
                }
            });
        });

        return canResetAllRowQuantities;
    }

    function populateVariantList () {
        var lineItem = {}; 
        _.forEach(vm.selectedProduct.variants, function (variant) {
            _.forEach(vm.selectedProduct.variantList, function(v){

                    var resultLineItem = _.find(variant.lineItems, function(lineitem){ 
                        return lineitem.variant2DetailName == v.variant2DetailName;
                    });

                    if(resultLineItem != undefined){
                        // lineItem = {
                        //     id : v.id,
                        //     tenantName : vm.selectedProduct.tenantName,
                        //     orderId : variant.orderId,
                        //     orderNumber: resultLineItem.orderNumber,
                        //     resellerName : variant.resellerName,
                        //     resellerPriority : variant.resellerPriority, 
                        //     variant1DetailName : resultLineItem.variant1DetailName,
                        //     variant2DetailName : resultLineItem.variant2DetailName,
                        //     variant2SortOrder : resultLineItem.variant2SortOrder,
                        //     fulfillableQuantity : resultLineItem.fulfillableQuantity, 
                        //     stockQuantity : resultLineItem.stockQuantity, 
                        //     quantity : resultLineItem.quantity,
                        //     keepRemainder : variant.keepRemainder
                        // }
                  
                    }
                    else {
                        lineItem = {
                            isFake: true,
                            id : v.id,              
                            tenantName : vm.selectedProduct.tenantName,
                            variant1DetailName : v.variant1DetailName,
                            variant2DetailName : v.variant2DetailName,
                            variant2SortOrder : v.variant2SortOrder,
                            fulfillableQuantity : 0, 
                            stockQuantity : 0, 
                            quantity : 0,
                            keepRemainder : false
                    }
                    variant.lineItems.push(lineItem);
                }
            });            
                   
        }); 
    }



    function loadFulfillableOrders() {
        loadSpinnerService.start('mainSpinner');
        ResellerOrdersApiService.getFulfillableOrders(vm.selectedWarehouse.id, vm.minimumAvailableStock, vm.selectedProduct.articleId, vm.selectedProduct.variantDetail1Id).then(function (response) {
            vm.selectedProduct.variants = response.data.orderVariants;
            vm.selectedProduct.variantList = response.data.variants;
            vm.selectedProduct.variantNames = [];
            populateVariantList();
            var result = _.sortBy(vm.selectedProduct.variantList, function(variant) { return variant.variant2SortOrder; });
            vm.selectedProduct.variantList = result;
            console.log(result);
            _.sortBy(vm.selectedProduct.variants, 'orderNumber');
            _.forEach(vm.selectedProduct.variants, function (ordVar) {
                ordVar.sumFulfillableQuantity = 0;
                ordVar.sumQuantity = 0;
                ordVar.keepRemainder = true;

                var sortedLineItems = _.sortBy(ordVar.lineItems, 'variant2SortOrder');
                ordVar.lineItems = sortedLineItems;
                
                _.forEach(ordVar.lineItems, function (li) {
                    if (!vm.selectedProduct.variantNames) { vm.selectedProduct.variantNames = []; }
                    if (vm.selectedProduct.variantNames.indexOf(li.variant2DetailName) === -1) {
                        vm.selectedProduct.variantNames.push(li.variant2DetailName);
                    }
                    ordVar.sumFulfillableQuantity += li.fulfillableQuantity;
                    ordVar.sumQuantity += li.quantity;
                });
                console.log(ordVar.lineItems);
            });
        }, function (error) {
            console.log(error);
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner', { force: true });
        });
    }

    function getFulfillableQuantitySum(variantName) {
        if (!variantName || variantName === '') { return 0; }

        var sum = 0;
        try {
            _.forEach(vm.selectedProduct.variants, function (artVar) {
                _.forEach(artVar.lineItems, function (li) {
                    if (li.variant2DetailName === variantName) {
                        sum += li.fulfillableQuantity;
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }

        return sum;
    }
    function getQuantitySum(variantName) {
        if (!variantName || variantName === '') { return 0; }

        var sum = 0;
        try {
            _.forEach(vm.selectedProduct.variants, function (artVar) {
                _.forEach(artVar.lineItems, function (li) {
                    if (li.variant2DetailName === variantName) {
                        sum += li.quantity;
                    }
                });
            });
        } catch (error) {
            console.log(error);
        }

        return sum;
    }
    function getDifference(variantName) {
        var diff = getStockQuantity(variantName) - getQuantitySum(variantName);
        return diff;
    }

    function preventInputLessThanZero(lineItem) {
        if (lineItem.quantity < 0) {
            lineItem.quantity = 0;
        }
    }

    function formatDifference(diff) {
        if (diff >= 0) {
            return '' + Math.abs(diff);
        } else {
            return '-' + Math.abs(diff);
        }
    }
}
